import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { IFormHandleExtended } from '../../../components/FormQuiz';
import { ChallengeOverview } from '../../../components/ChallengeOverview';
import { StepViewBreadcrumbs } from '../../../components/StepViewBreadcrumbs';
import { isVideoStep } from '../../../../../../selectors/video';
import { classes } from '../SidebarLayoutForParticipant.st.css';
import { IFollowingEntity } from '../../utils';
import { ButtonNames } from '../../../../../../contexts/main/biInterfaces';
import { ContentPlaceholders } from './ContentPlaceholders';
import { StepView } from './StepView';
import { OverviewControls } from './OverviewControls';
import { BaseControls } from './BaseControls';
import { Props } from '../interfaces';
import { TopControls } from './TopControls';

export interface BodyContentProps {
  props: Props;
  currentStep: ParticipantStep | null;
  goToMobileList: () => void;
  goToCurrentStep: () => void;
  getQuizData: () => any;
  resolveQuiz: (quizSubmissionId?: string) => Promise<void>;
  onStepResolve: (step: ParticipantStep) => Promise<void>;
  onNextEntity: (
    nextEntity: IFollowingEntity,
    withBI?: boolean,
  ) => Promise<void>;
  isProgramFinished: boolean;
  formQuizRef: React.RefObject<IFormHandleExtended>;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
}

export const BodyContent: React.FC<BodyContentProps> = ({
  props,
  currentStep,
  goToMobileList,
  goToCurrentStep,
  getQuizData,
  resolveQuiz,
  onStepResolve,
  onNextEntity,
  isProgramFinished,
  formQuizRef,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
}) => {
  const {
    challengeData: { challenge },
    isParticipantInSuspendedState,
    isParticipantInLockedState,
  } = props;
  const isStepActive = !!currentStep?.id;
  const isParticipantInNegativeState =
    isParticipantInSuspendedState || isParticipantInLockedState;
  const isStepActiveMagic = isStepActive || !props.settings.overviewTabDisplay;
  const isVideo = isVideoStep(currentStep?.source);

  return (
    <>
      <TopControls />
      <div
        className={`${classes.stepView} ${
          isParticipantInNegativeState ? classes.stepViewCentered : ''
        } ${isVideo ? classes.stepViewVideo : ''}`}
      >
        <div
          className={classes.stepViewContent}
          aria-live="polite"
          role="region"
        >
          {isStepActiveMagic ? (
            <>
              <ContentPlaceholders
                props={props}
                type="SidebarGeneral"
                withMobileBreadcrumbs={true}
                goToMobileList={goToMobileList}
              />
              <StepView
                props={props}
                currentStep={currentStep}
                goToMobileList={goToMobileList}
                goToCurrentStep={goToCurrentStep}
                getQuizData={getQuizData}
                resolveQuiz={resolveQuiz}
                formQuizRef={formQuizRef}
              />
            </>
          ) : null}

          {!isStepActiveMagic ? (
            <>
              <ChallengeOverview
                challenge={challenge}
                prefix={<StepViewBreadcrumbs goToMobileList={goToMobileList} />}
                pageRef={props.pageRef}
              />
              <ContentPlaceholders
                props={props}
                type="SidebarOverview"
                withMobileBreadcrumbs={false}
                goToMobileList={goToMobileList}
              />
            </>
          ) : null}
        </div>
      </div>

      <OverviewControls
        props={props}
        currentStep={currentStep}
        isProgramFinished={isProgramFinished}
        getQuizData={getQuizData}
        getIsStartDisabled={getIsStartDisabled}
        setStep={setStep}
        sendBiButtonClick={sendBiButtonClick}
      />
      <BaseControls
        props={props}
        currentStep={currentStep}
        isProgramFinished={isProgramFinished}
        getQuizData={getQuizData}
        onStepResolve={onStepResolve}
        onNextEntity={onNextEntity}
      />
    </>
  );
};
